import cookies from 'browser-cookies'

export const CSRF_TOKEN_COOKIE_NAME = 'spg-csrf-token'

export function getCSRFTokenFromCookie() {
  const csrfToken = cookies.get(CSRF_TOKEN_COOKIE_NAME)

  // remove quotations (if present) before returning
  return csrfToken?.replace(/^"(.+)"$/, '$1')
}
